import React, { useState, useEffect, useMemo } from "react";
import { Dialog } from "@material-ui/core";
import PropTypes from "prop-types";

import { deserializeFunction } from "utils/storeUtils";
import loader from "assets/images/hamster.gif";

import useStyles from "./useStyles";

const LoadingModal = ({ labelFunc }) => {
  const classes = useStyles();
  const [seconds, setSeconds] = useState(0);
  const addSecond = () => setSeconds((prevSeconds) => prevSeconds + 1);

  useEffect(() => {
    const interval = setInterval(addSecond, 1000);
    return () => clearInterval(interval);
  }, [labelFunc]);

  const getLabel = useMemo(() => labelFunc && deserializeFunction(labelFunc), [labelFunc]);

  const getMessage = () => {
    if (getLabel) return getLabel(seconds);
    return "Loading";
  };

  const message = getMessage();

  return (
    <Dialog classes={{ root: classes.root }} PaperProps={{ classes: { root: classes.paper } }} open>
      <img src={loader} alt="loader" className={classes.image} />
      <div className={classes.modalMessage}>
        <p className={classes.message}>{message}</p>
      </div>
    </Dialog>
  );
};

LoadingModal.propTypes = {
  labelFunc: PropTypes.string,
};

export default LoadingModal;
